import { render } from "./Modal.vue?vue&type=template&id=aab7e7e8&ts=true"
import script from "./Modal.vue?vue&type=script&lang=ts"
export * from "./Modal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\SCMQ\\project\\HTML\\mq-player-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__